import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import CheckIcon from "../../Icons/CheckIcon";
import ClipboardIcon from "../../Icons/ClipboardIcon";
import ShareIcon from "../../Icons/ShareIcon";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import useTenantGetHook from "../../customHooks/useTenantControlGetHook";
import { responsiveClassName } from "../../utils/classNames";
import ActivityLog from "./ActivityLog";
import OrderDetails from "./OrderDetails";
import OrderHistory from "./OrderHistory";
import { Link } from "react-router-dom";
import ReOrderIcon from "../../Icons/ReOrderIcon";
import Documents from "./components/Documents";

export default ({ selectedOrder }) => {
  const [selectedTab, setSelectedTab] = useState<
    "log" | "history" | "documents"
  >("history");
  const { data: websiteData, isLoading } = useTenantGetHook({
    url: APIS.WEBSITE,
    queryKey: ["get-website"],
    params: {},
  });
  const { data } = useGetHook({
    url: `${APIS.ORDER}${selectedOrder}/`,
    queryKey: [`order-${selectedOrder}`],
    params: {},
  });

  const [copied, setCopied] = useState(false);

  const trackingUrl = `https://${websiteData?.domain}/track?search=${data?.tracking_number}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(trackingUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <>
      <div className={tw`my-4 flex items-center justify-between `}>
        <div className={tw`flex items-center justify-start gap-x-6`}>
          <button
            className={tw`focus:outline-none text-sm`}
            onClick={() => setSelectedTab("history")}
            style={{
              borderBottom:
                selectedTab === "history" ? "4px solid var(--primary)" : "",
            }}
          >
            Order Detail
          </button>
          <button
            onClick={() => setSelectedTab("log")}
            style={{
              borderBottom:
                selectedTab === "log" ? "4px solid var(--primary)" : "",
            }}
            className={tw`focus:outline-none text-sm`}
          >
            Activity Log
          </button>
          <button
            onClick={() => setSelectedTab("documents")}
            style={{
              borderBottom:
                selectedTab === "documents" ? "4px solid var(--primary)" : "",
            }}
            className={tw`focus:outline-none text-sm`}
          >
            Documents
          </button>
        </div>
        <div className={tw`flex items-center gap-x-2`}>
          <div className={tw`relative group`}>
            <Link
              to={`order#/create?id=${selectedOrder}`}
              rel="noopener noreferrer"
              className={tw`focus:outline-none`}
            >
              <ReOrderIcon />
            </Link>
            <span
              className={tw`absolute left-1/2 -translate-x-1/2 -top-6 text-xs bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity`}
            >
              Reorder
            </span>
          </div>
          <div className={tw`relative group`}>
            <a
              href={trackingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={tw`focus:outline-none`}
            >
              <ShareIcon />
            </a>
            <span
              className={tw`absolute left-1/2 -translate-x-1/2 -top-6 text-xs bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity`}
            >
              Share
            </span>
          </div>
          <div className={tw`relative group mt-2`}>
            <button
              onClick={copyToClipboard}
              className={tw`focus:outline-none`}
            >
              {copied ? <CheckIcon /> : <ClipboardIcon />}
            </button>
            <span
              className={tw`absolute left-1/2 -translate-x-1/2 -top-6 text-xs bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity`}
            >
              {copied ? "Copied!" : "Copy"}
            </span>
          </div>
        </div>
      </div>
      <div className={responsiveClassName("", `min-h-[600px] min-w-[600px]`)}>
        <OrderDetails selectedOrder={selectedOrder} />
        {selectedTab === "history" && (
          <OrderHistory selectedOrder={selectedOrder} />
        )}

        {selectedTab === "log" && <ActivityLog selectedOrder={selectedOrder} />}
        {selectedTab === "documents" && (
          <Documents selectedOrder={selectedOrder} />
        )}
      </div>
    </>
  );
};
